import { isExpectedRouteError } from "@shuttlerock/error-handling";
import type { ErrorInfo } from "react";
import type { ClientOnErrorFunction } from "react-router";

// Logged errors reach Sentry (`captureConsoleIntegration`). An error a route
// boundary renders as a page of its own is expected: React Router keeps a
// loader's throw of one unlogged, so the same error thrown from render (a
// deferred read through `use()`) stays unlogged too.

/** `createRoot`'s `onCaughtError`, in place of React's `console.error` of every caught error. */
export function logCaughtError(error: unknown, errorInfo: ErrorInfo) {
  if (!isExpectedRouteError(error)) {
    console.error(error, errorInfo.componentStack);
  }
}

/**
 * `RouterProvider`'s `onError`, in place of React Router's logging of render
 * errors. It is also handed loader and action errors, which React Router never
 * logged; those carry no `errorInfo` and stay unlogged.
 */
export const logRouterError: ClientOnErrorFunction = (error, { errorInfo }) => {
  if (errorInfo && !isExpectedRouteError(error)) {
    console.error("React Router caught the following error during render", error);
  }
};
